import React from 'react';

const LoginButton = ({ onClick, isLoading, loadingDots, disabled = false, label = 'CONECTEAZA-TE' }) => (
  <button
    className="relative w-full h-16 mb-6 group overflow-hidden rounded-[32px] p-[2px] bg-gradient-to-br from-primary to-primary-light shadow-[0_20px_40px_-15px_rgba(0,90,224,0.5),10px_10px_20px_rgba(0,0,0,0.1),-10px_-10px_20px_rgba(255,255,255,0.9)] hover:shadow-[0_20px_45px_-15px_rgba(0,90,224,0.6),12px_12px_25px_rgba(0,0,0,0.12),-12px_-12px_25px_rgba(255,255,255,0.95)] hover:-translate-y-1 transition-all duration-300 disabled:opacity-70 active:scale-[0.98]"
    onClick={onClick}
    disabled={isLoading || disabled}
  >
    <div className="absolute inset-[2px] rounded-[30px] bg-gradient-to-br from-primary to-primary/90 backdrop-blur-xl" />
    <div className="absolute inset-0 rounded-[30px] bg-gradient-to-t from-white/0 via-white/10 to-white/20" />
    <div className="absolute inset-0 rounded-[30px] shadow-[inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_8px_rgba(0,0,0,0.2)]" />
    <span className="relative z-10 flex items-center justify-center h-full text-white text-base font-bold tracking-wide drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)]">
      {isLoading ? (
        <span className="flex items-center">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          LOGARE{loadingDots}
        </span>
      ) : label}
    </span>
  </button>
);

export default LoginButton;
